export const isE2E = (): boolean => {
  return !!window.isPlaywrightRunning;
};

export const isHeadless = (): boolean => {
  const userAgent = window.navigator?.userAgent.toLowerCase();
  return (
    navigator?.webdriver ||
    userAgent.includes('headless') ||
    userAgent.includes('phantomjs')
  );
};

export const isProdEnv = (): boolean =>
  window.env.VITE_ENV === 'prod-master' || window.env.VITE_ENV === 'prod-eu';
